import { Page, PageTitle } from '../../../../components';
import { ContractActivityDetails } from './ContractActivityDetails';

export const ContractActivity = () => {
  return (
    <Page title="Contract Activity">
      <PageTitle title="Contract Activity" />
      <ContractActivityDetails />
    </Page>
  );
};
